function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.813,
    height: 39.357,
    viewBox: "0 0 49.813 39.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10786"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 7477",
    d: "M1519.855 168.036a6.972 6.972 0 0 0-5.622-2.54H1496.7v-33.317h18.254a4.9 4.9 0 0 1 4.9 4.9z",
    style: {
      fill: "none",
      stroke: "#3d55dc",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.5px"
    },
    transform: "translate(-1494.948 -130.429)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 7478",
    d: "M1521.568 168.036a6.968 6.968 0 0 1 5.621-2.54h17.535v-33.317h-18.254a4.9 4.9 0 0 0-4.9 4.9z",
    transform: "translate(-1496.661 -130.429)",
    style: {
      fill: "none",
      stroke: "#3d55dc",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.5px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.d26e97b5.svg";
export { ForwardRef as ReactComponent };